import { render, staticRenderFns } from "./request-invite-button.vue?vue&type=template&id=4d273026&lang=pug"
import script from "./request-invite-button.vue?vue&type=script&lang=js"
export * from "./request-invite-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports